import p from 'x/config/platform-specific'

const XTimePicker = p.comp.getXTimePicker()

export default XTimePicker
